import {
  createColumn,
  formatDateTime,
  numberFormat,
} from "../../utils/helpers";
import { TFieldConfig } from "../../types/common";
import { API_DISTRICTS, API_INVOICES_PAID } from "../../utils/apis";
import useGet from "../common/useGet";
import { useEffect } from "react";

interface UseVehicleLedgerReceiptsProps {
  form: any;
  updateFormValue: (field: string, value: any) => void;
  updateFormValues: (values: any) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  filters: any;
  setFilters: (filters: any) => void;
  setError: (error: any) => void;
}

export const useVehicleLedgerReceipts = ({}: UseVehicleLedgerReceiptsProps) => {
  const { loadData: getDistricts, data: districts } = useGet();
  useEffect(() => {
    getDistricts({ api: API_DISTRICTS });
  }, []);

  // Map districts to use name as value instead of id
  const districtOptions =
    districts?.map((district: any) => ({
      value: district.name,
      label: district.name,
    })) || [];

  const searchFields: TFieldConfig[] = [
    {
      field_name: "car_number",
      label: "Car Number",
      type: "text",
      props: {
        placeholder: "Enter car number",
        required: true,
      },
    },
    {
      field_name: "district_name",
      type: "select",
      props: {
        options: districtOptions,
        placeholder: "Select district",
      },
    },
    {
      field_name: "invoice_min_date",
      label: "Start Date",
      type: "date",
      props: {
        placeholder: "YYYY-MM-DD",
        format: "YYYY-MM-DD",
      },
    },
    {
      field_name: "invoice_max_date",
      label: "End Date",
      type: "date",
      props: {
        placeholder: "YYYY-MM-DD",
        format: "YYYY-MM-DD",
      },
    },
  ];

  const tableColumns = () => [
    createColumn("generated_at", false, "Date"),
    createColumn("invoice_number", false, "Invoice No."),
    createColumn("type", false, "Type"),
    createColumn("amount", false, "Amount"),
    createColumn("district_name", false, "District"),
    createColumn("created_by", false, "Created By"),
  ];

  const tableData = (data: any) => {
    if (!data) return [];

    return data?.results?.map((item: any) => ({
      ...item,
      generated_at: item.generated_at
        ? formatDateTime(item.generated_at)
        : "N/A",
      invoice_number: item.invoice_number || "N/A",
      amount: item.amount ? numberFormat(item.amount) : "N/A",
    }));
  };

  const api = API_INVOICES_PAID;
  const tableTitle = "Receipts";
  const initialFilters = {};
  // const exportData = {
  //   api: `${API_INVOICES_PAID}/export/`,
  //   fileName: "vehicle_receipts.xlsx",
  // };
  // const printData = {
  //   api: "/api/vehicle-ledger/receipts/print/",
  //   fileName: "vehicle_receipts.pdf",
  // };

  return {
    searchFields,
    tableColumns,
    tableData,
    tableTitle,
    api,
    initialFilters,
    // exportData,
    // printData,
  };
};
